import {authMiddleware} from "./loginAction";
import cfg, {handleResponse} from "../constants";

/**
 * Материалы маршрута — то, что клиентка видит в приложении на вкладке «Материалы».
 *
 * Маршрут состоит из ступеней, ступень из материалов, материал из файлов.
 * Ступень — отрезок программы в днях от старта: тот же счёт, по которому CRM
 * раскладывает клиенток по периодам курса. Ступень клиентки сервер вычисляет сам,
 * руками её никто не переключает.
 */

// materialStagesAction - ступени маршрута
export const materialStagesAction = () => (dispatch, getState) => {
  const headers = authMiddleware(dispatch, getState);
  return fetch(cfg.base_url + '/auth/material-stages', {headers}).then(handleResponse);
};

// materialStagePresetsAction - ступени из описания курса.
//
// Порядок и границы в днях уже известны CRM: набирать их руками незачем, а
// разойдись они с периодами курса — сервер решал бы про ступень клиентки одно,
// а карточка показывала другое.
export const materialStagePresetsAction = () => (dispatch, getState) => {
  const headers = authMiddleware(dispatch, getState);
  return fetch(cfg.base_url + '/auth/material-stage-presets', {headers}).then(handleResponse);
};

// materialStagesFromCourseAction - завести недостающие ступени одним нажатием.
//
// Повторное нажатие ничего не портит: уже заведённые пропускаются.
export const materialStagesFromCourseAction = () => (dispatch, getState) => {
  const headers = authMiddleware(dispatch, getState);
  return fetch(cfg.base_url + '/auth/material-stage-presets', {method: "POST", headers}).then(handleResponse);
};

// materialStageSaveAction - завести ступень или поправить её.
//
// Одной ручкой: в панели это одна форма, и разносить её на две незачем. Без
// идентификатора сервер заводит новую.
export const materialStageSaveAction = (stage) => (dispatch, getState) => {
  const headers = authMiddleware(dispatch, getState);
  return fetch(cfg.base_url + '/auth/material-stage', {
    method: "POST",
    body: JSON.stringify(stage),
    headers
  }).then(handleResponse);
};

// materialStageDeleteAction - убрать ступень.
//
// Удаление мягкое: материал мог уйти клиентке в переписку карточкой, и та
// обязана открываться.
export const materialStageDeleteAction = (id) => (dispatch, getState) => {
  const headers = authMiddleware(dispatch, getState);
  return fetch(cfg.base_url + '/auth/material-stage/' + id, {method: "DELETE", headers}).then(handleResponse);
};

// materialsAction - материалы всех ступеней или одной
export const materialsAction = (stageId) => (dispatch, getState) => {
  const headers = authMiddleware(dispatch, getState);
  const query = stageId ? '?stage_id=' + encodeURIComponent(stageId) : '';
  return fetch(cfg.base_url + '/auth/material-list' + query, {headers}).then(handleResponse);
};

// materialsForClientAction - материалы ступени, на которой клиентка сейчас.
//
// Ступень считает сервер — днями от старта программы, теми же, что и для
// приложения. Куратор не обязан помнить, на какой ступени каждая из его
// клиенток, а разойдись счёт — он отправлял бы материал не той ступени.
export const materialsForClientAction = (clientId) => (dispatch, getState) => {
  const headers = authMiddleware(dispatch, getState);
  return fetch(cfg.base_url + '/auth/client-materials/' + clientId, {headers}).then(handleResponse);
};

// materialSaveAction - завести материал или поправить его
export const materialSaveAction = (material) => (dispatch, getState) => {
  const headers = authMiddleware(dispatch, getState);
  return fetch(cfg.base_url + '/auth/material', {
    method: "POST",
    body: JSON.stringify(material),
    headers
  }).then(handleResponse);
};

// materialDeleteAction - убрать материал, тоже мягко
export const materialDeleteAction = (id) => (dispatch, getState) => {
  const headers = authMiddleware(dispatch, getState);
  return fetch(cfg.base_url + '/auth/material/' + id, {method: "DELETE", headers}).then(handleResponse);
};

// materialUploadAction - залить файл материала.
//
// Без названия файл принадлежит самому материалу: у видеозаписи он один.
// С названием становится пособием — отдельной строкой в списке у клиентки.
//
// Content-Type не ставим руками: у multipart в нём граница, и браузер знает её,
// а мы нет — заданный заголовок ломает разбор на сервере.
export const materialUploadAction = (id, file, title) => (dispatch, getState) => {
  const token = authMiddleware(dispatch, getState, false, true);
  const formData = new FormData();
  formData.append('file', file, file.name);
  if (title) {
    formData.append('title', title);
  }

  return fetch(cfg.base_url + '/auth/material/' + id + '/file', {
    method: "POST",
    headers: {'Authorization': 'Bearer ' + token},
    body: formData
  }).then(handleResponse);
};

// materialFileDeleteAction - снять файл пособия вместе с объектом в хранилище
export const materialFileDeleteAction = (id) => (dispatch, getState) => {
  const headers = authMiddleware(dispatch, getState);
  return fetch(cfg.base_url + '/auth/material-file/' + id, {method: "DELETE", headers}).then(handleResponse);
};

